import React from "react";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import FeedbackForm from "./FeedbackForm"; // Adjust the import path as necessary
import useFeedbackStore from "../../store/FeedbackStore";

const FeedbackDrawer = ({ open, onClose }) => {
  const clearFeedback = useFeedbackStore((state) => state.clearFeedback);

  /*  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setIsOpen(open);
  }; */

  const closeHandler = () => {
    clearFeedback();
    onClose();
  };

  return (
    <div>
      <Drawer
        sx={{
          "& .MuiBox-root": {
            width: "500px",
            padding: "48px",

            "& form .MuiBox-root": {
              width: "400px",
              padding: 0,
            },
          },
        }}
        anchor="right"
        open={open}
        onClose={closeHandler}
      >
        <FeedbackForm closeHandler={closeHandler} />
      </Drawer>
    </div>
  );
};

export default FeedbackDrawer;
